import React from "react";
import UserManagmentTable from "../components/Dashboard/UserManagmentTable";

function AllUsers() {
  return <UserManagmentTable />;
}

export default AllUsers;
